const ClockIcon = () => {
    return (
        <svg className={"svg-icon"} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.9453 21C17.9159 21 21.9453 16.9706 21.9453 12C21.9453 7.02944 17.9159 3 12.9453 3C7.97475 3 3.94531 7.02944 3.94531 12C3.94531 16.9706 7.97475 21 12.9453 21Z"
                stroke="#141615" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12.9453 12H18.1953" stroke="#141615" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path d="M16.6576 15.7123L12.9453 12" stroke="#141615" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    )
}

export default ClockIcon